import { Box, Grid, Theme, Typography } from '@mui/material';
import { KeyValue } from './personalDetails';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';

export default function KycDetails({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  const { currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: {xs:"15px",sm:'25px'}
        })}
        mt={5}>
        <Box >
          <Grid container >
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
              Additional KYC Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: "0.02px" }}>{title}</SubHeading>

                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue
                      title={'Gross Annual Income'}
                      description={applicant.grossAnnualIncome}
                    />
                    <KeyValue
                      title={'Gross Annual Income as on Date'}
                      description={formatShortDate(applicant.grossAnnualIncomeDate)}
                    />
                    <KeyValue title={`NetWorth (in ${currencyCode})`} description={applicant.netWorth} />
                    <KeyValue
                      title={'Networth as on Date'}
                      description={formatShortDate(applicant.netWorthDate)}
                    />
                    <KeyValue
                      title={'Politically Exposed Person (PEP) Status'}
                      description={applicant.politicallyExposedPersonStatus}
                    />
                    <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />
                  </Grid>

                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box >
    </>
  );
}
